<template>
  <div class="search-result">
    <Header :showBack="true" :callback="getUserInfo" />
    <Search :attr-keyword="keyword || kwos" :attr-type-index="typeIndex" :callback="searchAction" />
    <div class="sr-content">
      <div class="search-filter">
        <p class="sf-news" :class="{ active: filterType === 'news' }" @click="tabAction('news')"><span>Latest</span></p>
        <p class="sf-hot" :class="{ active: filterType === 'hot' }" @click="tabAction('hot')"><span>Hottest</span></p>
        <p class="sf-filter" v-if="typeIndex != 2" @click="showFilterAction"><span>Sift</span></p>
      </div>
      <ul class="search-item" v-if="typeIndex == 0">
        <li v-for="item in list" :key="item.details_id">
          <a
            :href="`/#/prodetail?id=${typeIndex == 0 ? item.details_id : item.formula_id}&munufacturer_id=${item.munufacturer_id}&source=${source}`">
            <div class="search-iteml">
              <div class="search-pname">
                <strong v-html="item.product_name"></strong>
                <div class="search-yl" v-if="item.is_recommend == 1"><img src="../../assets/images/icon-yl.png" alt="">
                </div>
                <img class="label-join" src="../../assets/images/icon-join.png" v-if="item.activity_tag == 1">
                <img class="label-recom" src="../../assets/images/icon-recommend.png" v-if="item.is_select_banner == 1">
              </div>
              <p><span v-if="item.chemical_name" v-html="item.chemical_name"></span> <span v-if="item.munufacturer_name"
                  v-html="item.munufacturer_name" @click="navigateToMunufacturer(item.munufacturer_id)"></span></p>
              <p class="pro-desc"><span v-if="item.product_description" v-html="item.product_description"></span></p>
            </div>
            <div class="search-itemr">
              <p>Find<br />out more</p>
              <img src="../../assets/images/nicon-search-view-detail.png">
            </div>
          </a>
        </li>
      </ul>
      <ul class="search-formula-item" v-else-if="typeIndex == 1">
        <li v-for="item in list" :key="item.formula_id">
          <a :href="`/#/formuladetails?formula_id=${item.formula_id}`">
            <div class="search-formula-itemt">
              <strong><span v-html="item.formula_name"></span>由<span
                  v-html="item.munufacturer_abbreviation"></span>提供</strong>
              <div class="characteristic">
                <span v-for="label in item.formula_label_array" :key="label" v-html="label"></span>
              </div>
              <p v-html="'应用领域：' + item.adhibition_type"></p>
              <p v-html="'提供商：' + item.formula_company"></p>
            </div>
            <div class="search-formula-btn">
              <img src="../../assets/images/icon-yl.png" alt="" v-if="item.is_recommend == 1">
              Find out more
            </div>
          </a>
        </li>
      </ul>
      <ul class="search-formula-item" v-else>
        <li v-for="item in list" :key="item.sample_id" @click="initiateDemo(item)">
          <div class="a">
            <div class="search-formula-itemt"><strong><span>{{ item.goods_name }}</span></strong>
              <p>拿样数量：{{ item.number }}</p>
              <p>应用领域：{{ item.application_area }}</p>
              <p>品质要求：{{ item.quality }}</p>
            </div>
            <div class="sybtn"><i class="wygy-btn">我要供样</i></div>
          </div>
        </li>
      </ul>
      <p class="tips" v-show="!isLoading && list.length === 0">No more data available</p>
    </div>
    <Footer />
    <div class="filter-panel" v-show="filterVisible">
      <div class="filter-mask" @click="hideFilterAction"></div>
      <div class="filter-panel-content">
        <div class="filter-panel-form">
          <dl :class="{ active: manufacturerContentVisible }">
            <dt>Producers/Suppliers <img src="../../assets/images/nicon-arrow-down2.png" alt=""
                @click="setManufacturerContentVisible"></dt>
            <dd>
              <!-- <div class="filter-panel-search">
                <input type="text" v-model="modelManufacturer" @keydown="searchManufacturerAction">
                <img src="../../assets/images/search-icon.png" alt="" @click="searchManufacturerActionByBtn">
              </div> -->
              <ul id="manufacturer" class="row1" v-show="manufacturerList.length > 0">
                <li :class="{ active: manufacturerKeys[index] }" v-for="(item, index) in manufacturerList"
                  :key="item.munufacturer_id" @click="selectManufacturerItem(index)">{{ typeIndex == 0 ?
                    item.munufacturer_name : item.formula_company }}</li>
              </ul>
              <p class="tips" v-show="manufacturerList.length === 0">No more data available</p>
            </dd>
          </dl>
          <dl :class="{ active: performanceContentVisible }" v-if="typeIndex == 0">
            <dt>Performance <img src="../../assets/images/nicon-arrow-down2.png" alt=""
                @click="setPerformanceContentVisible">
            </dt>
            <dd>
              <!-- <div class="filter-panel-search">
                <input type="text" v-model="modelPerformance" @keydown="searchPerformanceAction"
                  @blur="inputBlurAction">
                <img src="../../assets/images/search-icon.png" alt="" @click="searchPerformanceActionByBtn">
              </div> -->
              <div class="filter-panel-t2" id="performance" v-show="performanceList.length > 0">
                <div class="filter-panel-t2-container" id="performance-container">
                  <div class="filter-panel-t2-item" v-for="(item, index) in performanceList" :key="item.pid">
                    <strong :class="{ active: performanceKeys[index] }" @click="selectPerformanceItem(index)">{{
                      item.name }}</strong>
                    <p :class="{ active: performanceKeys[index] }">
                      <input type="text" v-model="performanceModels[index].start" @blur="inputBlurAction" /> - <input
                        type="text" v-model="performanceModels[index].end" @blur="inputBlurAction" />
                    </p>
                  </div>
                </div>
              </div>
              <p class="tips" v-show="performanceList.length === 0">No more data available</p>
            </dd>
          </dl>
          <dl :class="{ active: formulaCateContentVisible }" v-if="typeIndex == 1">
            <dt>配方分类 <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="setFormulaCateContentVisible">
            </dt>
            <dd>
              <ul>
                <li :class="{ active: formulaCateKeys[index] }" v-for="(item, index) in formulaCateList" :key="item.id"
                  @click="selectFormulaCateItem(index)">{{ item.name }}</li>
              </ul>
            </dd>
          </dl>
          <dl :class="{ active: formulaContentVisible }" v-if="typeIndex == 1">
            <dt>配方特点 <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="setFormulaContentVisible"></dt>
            <dd>
              <div class="filter-panel-search">
                <input type="text" v-model="modelFormula" @keydown="searchFormulaAction" @blur="inputBlurAction">
                <img src="../../assets/images/search-icon.png" alt="" @click="searchFormulaActionByBtn">
              </div>
              <ul id="formula" v-show="formulaList.length > 0">
                <li :class="{ active: formulaKeys[index] }" v-for="(item, index) in formulaList" :key="item.label_id"
                  @click="selectFormulaItem(index)">{{ item.label_name }}</li>
              </ul>
              <p class="tips" v-show="formulaList.length === 0">No more data available</p>
            </dd>
          </dl>
          <dl :class="{ active: proContentVisible }" v-if="typeIndex == 0">
            <dt>Product Classification <img src="../../assets/images/nicon-arrow-down2.png" alt=""
                @click="setProContentVisible" v-if="proLevel.length > 0"></dt>
            <dd class="filter-panel-t3">
              <div class="level" :class="{ active: item.open }" v-for="item in proLevel" :key="item.product_id">
                <div class="level-dt">
                  <p @click="proLevelCheck(item)">
                    <img src="../../assets/images/check-active.png" v-show="item.checked" />
                    <img src="../../assets/images/check.png" v-show="!item.checked" />
                    {{ item.classification_english_name }}
                  </p>
                  <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="toggleLevelVisible(item)"
                    v-if="item.children.length > 0" />
                </div>
                <div class="level-dd">
                  <div class="level-item level2" :class="{ active: citem2.open }" v-for="citem2 in item.children"
                    :key="citem2.product_id">
                    <div class="level-item-dt">
                      <p @click="proLevelCheck(citem2)">
                        <img src="../../assets/images/check-active.png" v-show="citem2.checked" />
                        <img src="../../assets/images/check.png" v-show="!citem2.checked" />
                        {{ citem2.classification_english_name }}
                      </p>
                      <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="toggleLevelVisible(citem2)"
                        v-if="citem2.children.length > 0" />
                    </div>
                    <div class="level-item-dd">
                      <div class="level-item level3" :class="{ active: citem3.open }" v-for="citem3 in citem2.children"
                        :key="citem3.product_id">
                        <div class="level-item-dt">
                          <p @click="proLevelCheck(citem3)">
                            <img src="../../assets/images/check-active.png" v-show="citem3.checked" />
                            <img src="../../assets/images/check.png" v-show="!citem3.checked" />
                            {{ citem3.classification_english_name }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
          <dl :class="{ active: appContentVisible }" v-if="typeIndex == 0">
            <dt>Application classification <img src="../../assets/images/nicon-arrow-down2.png" alt=""
                @click="setAppContentVisible" v-if="appLevel.length > 0"></dt>
            <dd class="filter-panel-t3">
              <div class="level" :class="{ active: item.open }" v-for="item in appLevel" :key="item.id">
                <div class="level-dt">
                  <p @click="proLevelCheck(item)">
                    <img src="../../assets/images/check-active.png" v-show="item.checked" />
                    <img src="../../assets/images/check.png" v-show="!item.checked" />
                    {{ item.classification_english_name }}
                  </p>
                  <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="toggleLevelVisible(item)"
                    v-if="item.children.length > 0" />
                </div>
                <div class="level-dd">
                  <div class="level-item level2" :class="{ active: citem2.open }" v-for="citem2 in item.children"
                    :key="citem2.id">
                    <div class="level-item-dt">
                      <p @click="proLevelCheck(citem2)">
                        <img src="../../assets/images/check-active.png" v-show="citem2.checked" />
                        <img src="../../assets/images/check.png" v-show="!citem2.checked" />
                        {{ citem2.classification_english_name }}
                      </p>
                      <img src="../../assets/images/nicon-arrow-down2.png" alt="" @click="toggleLevelVisible(citem2)"
                        v-if="citem2.children.length > 0" />
                    </div>
                    <div class="level-item-dd">
                      <div class="level-item level3" :class="{ active: citem3.open }" v-for="citem3 in citem2.children"
                        :key="citem3.id">
                        <div class="level-item-dt">
                          <p @click="proLevelCheck(citem3)">
                            <img src="../../assets/images/check-active.png" v-show="citem3.checked" />
                            <img src="../../assets/images/check.png" v-show="!citem3.checked" />
                            {{ citem3.classification_english_name }}
                          </p>
                          <img src="../../assets/images/nicon-arrow-down2.png" alt=""
                            @click="toggleLevelVisible(citem3)" v-if="citem3.children.length > 0" />
                        </div>
                        <div class="level-item-dd">
                          <div class="level-item level4" :class="{ active: citem4.open }"
                            v-for="citem4 in citem3.children" :key="citem4.id">
                            <div class="level-item-dt">
                              <p @click="proLevelCheck(citem4)">
                                <img src="../../assets/images/check-active.png" v-show="citem4.checked" />
                                <img src="../../assets/images/check.png" v-show="!citem4.checked" />
                                {{ citem4.classification_english_name }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div class="filter-panel-confirm">
          <button @click="filterConfirmAction">Confirm</button>
        </div>
      </div>
    </div>
    <demand-btn :instance="$demoInstance"
      :saveOptions="{ data_source: 2, u_source: Number(typeIndex) + 1, crm_source: source === 'cms' ? 1 : 0 }" />
    <Loader :visible="loaderVisible" />
  </div>
</template>
<script>
  import header from '../common/header';
  import search from '../common/search';
  import footer from '../common/footer';
  import loader from '../ui/loader.vue';
  import axios from 'axios';
  import qs from 'qs';
  import config from '../../common/config.js';

  export default {
    data() {
      return {
        filterType: 'news', // news 最新 hot 热门
        filterVisible: false, // 筛选可视化
        filterParams: {}, // 筛选参数
        typeIndex: this.$route.query.type || 0, //搜索类型 0 产品 1 配方
        keyword: this.$route.query.keyword || '', // 关键字
        kwos: this.$route.query.kwos || '',
        source: this.$route.query.source || '',
        page: 1, // 页码
        list: [], // 列表数据
        isLoading: true, // 是否加载中
        loadOver: false, // 是否加载完
        loaderVisible: true, // 加载可视化
        modelManufacturer: '', // 生产商
        manufacturerPage: 1, // 生产商页码
        manufacturerList: [], // 生产商列表
        isManufacturerLoading: true, // 是否加载生产商中
        manufacturerLoadOver: false, // 生产商没有更多数据
        manufacturerKeys: [], // 生产商列表项选择
        manufacturerVisible: false, // 生产商
        manufacturerContentVisible: true, // 生产商内容可视化
        modelPerformance: '', // 性能
        modelFormula: '', // 配方特点
        performancePage: 1, // 性能页码
        performanceList: [], //性能列表
        performanceModels: [], // 性能input model
        isPerformanceLoading: true, // 是否加载性能列表中
        performanceLoadOver: false, // 性能没有更多数据
        performanceKeys: [], // 性能列表项是否展开
        performanceContentVisible: true, // 性能内容可视化
        proContentVisible: true, // 产品分类可视化
        proLevel: [], // 分类
        proLevelBackups: [], // 分类备份
        appContentVisible: true, // 应用分类可视化
        appLevel: [], // 应用分类
        appLevelBackups: [], // 应用分类备份
        formulaPage: 1, // 配方页码
        formulaList: [], //配方列表
        isFormulaLoading: true, // 是否加载配方列表中
        formulaLoadOver: false, // 配方没有更多数据
        formulaKeys: [], // 配方列表项是否展开
        formulaContentVisible: true, // 配方内容可视化
        formulaCatePage: 1, // 配方分类页码
        formulaCateList: [], //配方分类列表
        formulaCateKeys: [], // 配方分类列表项是否展开
        formulaCateContentVisible: true, // 配方分类内容可视化
        physicalIds: [], // 性能选择结果
        physicalStar: [], // 性能开始值
        physicalEnd: [], // 性能结束值
        productIds: [], // 产品选择结果
        applicationIds: [], // 应用分类选择结果
        companyIds: [], // 生厂商选择结果
        adhibitionIds: [], // 配方分类选择结果
        formulaLabelIds: [], // 配方特点选择结果
        userInfo: {}
      }
    },
    metaInfo: {
      title: 'AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China',
      meta: [{
        name: "keywords",
        content: "chemical raw material, chemical properties,properties,chemical brand,coatings, inks, plastic,adhesive,PE,PP,PVC,resin,pigments, additives,TDS,MSDS,SDS"
      },
      {
        name: "description",
        content: "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc."
      }
      ]
    },
    components: {
      Header: header,
      Search: search,
      Footer: footer,
      Loader: loader
    },
    mounted() {
      _hmt.push(['_trackPageview', `/${window.location.hash}`]);
      WeChatShare({
        callback: function () {
          var title = `AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China`,
            desc = `Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc.`,
            imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg';
          wx.onMenuShareAppMessage({
            title: title,
            desc: desc,
            link: window.location.href,
            imgUrl: imgUrl
          });
          wx.onMenuShareTimeline({
            title: title + " - " + desc,
            link: window.location.href,
            imgUrl: imgUrl
          });
        },
        data: 'jsApiDomain=&url=' + encodeURIComponent(window.location.href),
        url: config.MAPI
      });

      const paramManufacturer = [],
        paramProduct = [],
        paramApplication = [];

      // 获取产品分类参数、配方分类参数
      if (this.typeIndex == 0) {
        let queryObj = this.$route.query;
        let queryLevel1 = queryObj.level1 ? queryObj.level1.split(',') : [];
        let queryLevel2 = queryObj.level2 ? queryObj.level2.split(',') : [];
        let queryLevel3 = queryObj.level3 ? queryObj.level3.split(',') : [];
        let queryLevel4 = queryObj.level4 ? queryObj.level4.split(',') : []
        let queryLevel5 = queryObj.level5 ? queryObj.level5.split(',') : []

        if (queryLevel1.length) {
          queryLevel1.forEach((v, k) => {
            const pid = v + '_' + queryLevel2[k] + '_' + queryLevel3[k] + '_' + queryLevel4[k] + '_' + queryLevel5[k]
            const paramPid = v + '-' + queryLevel2[k] + '-' + queryLevel3[k] + '-' + queryLevel4[k] + '-' + queryLevel5[k]
            let currentId = v
            let level = 0
            if (queryLevel2[k] > 0) {
              currentId = queryLevel2[k]
              level = 1
            }
            if (queryLevel3[k] > 0) {
              currentId = queryLevel3[k]
              level = 2
            }
            if (queryLevel4[k] > 0) {
              currentId = queryLevel4[k]
              level = 3
            }
            if (queryLevel5[k] > 0) {
              currentId = queryLevel5[k]
              level = 4
            }
            this.productIds.push(pid)
            paramProduct.push([paramPid, '', currentId, level])
          })
        }
        let queryAppLevel1 = queryObj.appLevel1 ? queryObj.appLevel1.split(',') : []
        let queryAppLevel2 = queryObj.appLevel2 ? queryObj.appLevel2.split(',') : []
        let queryAppLevel3 = queryObj.appLevel3 ? queryObj.appLevel3.split(',') : []
        let queryAppLevel4 = queryObj.appLevel4 ? queryObj.appLevel4.split(',') : []
        let queryAppLevel5 = queryObj.appLevel5 ? queryObj.appLevel5.split(',') : []

        if (queryAppLevel1.length) {
          queryAppLevel1.forEach((v, k) => {
            const appid = v + '_' + queryAppLevel2[k] + '_' + queryAppLevel3[k] + '_' + queryAppLevel4[k] + '_' + queryAppLevel5[k]
            const paramAppid = v + '-' + queryAppLevel2[k] + '-' + queryAppLevel3[k] + '-' + queryAppLevel4[k] + '-' + queryAppLevel5[k]
            let currentId = v
            let level = 0
            if (queryAppLevel2[k] > 0) {
              currentId = queryAppLevel2[k]
              level = 1
            }
            if (queryAppLevel3[k] > 0) {
              currentId = queryAppLevel3[k]
              level = 2
            }
            if (queryAppLevel4[k] > 0) {
              currentId = queryAppLevel4[k]
              level = 3
            }
            if (queryAppLevel5[k] > 0) {
              currentId = queryAppLevel5[k]
              level = 4
            }
            this.applicationIds.push(appid);
            paramApplication.push([paramAppid, '', currentId, level])
          })
        }
      } else {
        let _formulaCate = this.$route.query.formulacate;
        if (_formulaCate) this.adhibitionIds.push(_formulaCate);
      }
      let _manufacturerId = this.$route.query.manufacturer,
        _manufacturerName = this.$route.query.manufacturername;

      if (_manufacturerId) this.companyIds.push(_manufacturerId);
      if (_manufacturerName) _manufacturerName = decodeURIComponent(decodeURIComponent(_manufacturerName));

      // 获取页面数据
      this.getData();
      this.getManufacturer(true);

      window.addEventListener('scroll', this.handleScroll);
      document.getElementById('manufacturer').addEventListener('scroll', this.manufacturerScrollAction);
      if (this.typeIndex == 1) {
        this.getFormula();
        this.getFormulaCate();
        document.getElementById('formula').addEventListener('scroll', this.formulaScrollAction);
      } else {
        this.getPerformance();

        if (_manufacturerId) paramManufacturer.push([_manufacturerId, _manufacturerName]);
        this.filterParams.munufacturer = paramManufacturer;
        this.filterParams.productCate = paramProduct;
        this.filterParams.applicationCate = paramApplication;
        this.getProAndAppCate(true);

        if (this.typeIndex < 2) {
          document.getElementById('performance').addEventListener('scroll', this.performanceScrollAction);
        }
      }
    },
    deactivated() {
      this.filterVisible = false
      window.removeEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
      this.filterVisible = false
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      getUserInfo(userInfo) {
        this.userInfo = userInfo
      },
      /**
       * 最新、最热切换
       * @param {string} type 类型
       */
      tabAction(type) {
        if (this.filterType == type) return;
        this.resetDataAction();
        this.filterType = type;
        this.loaderVisible = true;
        this.getData();
      },
      // 获取页面数据
      getData() {
        const postData = {
          keyName: this.keyword,
          page: this.page,
          pageSize: 10,
          orderKey: this.filterType === 'news' ? 1 : 2,
          physicalIds: this.physicalIds,
          physicalStar: this.physicalStar,
          physicalEnd: this.physicalEnd,
          companyIds: this.companyIds,
          adhibitionIds: this.adhibitionIds,
          formulaLabelIds: this.formulaLabelIds
        };
        if (this.productIds.length > 0) {
          postData.productIds = this.productIds;
        }
        if (this.applicationIds.length > 0) {
          postData.applicationIds = this.applicationIds;
        }

        if (this.typeIndex == 2) {
          axios.post(config.MallApi + 'api/wshop/sample/sample-list',
            qs.stringify({
              goods_name: this.keyword,
              page: this.page,
              pageSize: 10,
              orderKey: this.filterType === 'news' ? 1 : 2,
            }))
            .then(r => {
              this.isLoading = false;
              this.loaderVisible = false;
              r = r.data;
              if (r.error_code === 0) {
                this.list = [...this.list, ...r.data.model];
                if (r.data.current_page >= r.data.page_count) {
                  this.loadOver = true;
                }
              }
            }).catch(err => {
              this.isLoading = false;
              this.loaderVisible = false;
            });
        } else {
          axios.post(config.PHPHOST + 'api/web/index.php?r=second/search/index&typeId=' + (this.typeIndex == 0 ? 1 : 2),
            qs.stringify(postData))
            .then(r => {
              this.isLoading = false;
              this.loaderVisible = false;
              r = r.data;
              if (r.error_code === 0) {
                this.list = [...this.list, ...r.data.model];
                if (r.data.page >= r.data.page_count) {
                  this.loadOver = true;
                }
              }
            }).catch(err => {
              this.isLoading = false;
              this.loaderVisible = false;
            });
        }

      },
      // 重制页面数据
      resetDataAction() {
        this.list = [];
        this.page = 1;
        this.filterType = 'news';
        this.isLoading = true;
        this.loadOver = false;
      },
      // 滚动加载
      handleScroll() {
        if (this.isLoading || this.loadOver) return;
        if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 650 || document.body.scrollHeight -
          document.documentElement.scrollTop - window.innerHeight < 650) {
          this.loadmore()
        }
      },
      // 加载更多
      loadmore() {
        this.isLoading = true;
        this.page++;
        this.getData();
      },
      /**
       * 搜索自定义处理
       * @param {string} value 搜索内容
       */
      searchAction(value) {
        window.location.href = window.location.origin + '/#/search/result?keyword=' + value + '&r=' +
          new Date().getTime();
      },
      // 显示筛选面板
      showFilterAction() {
        this.filterVisible = true;
      },
      // 隐藏筛选面板
      hideFilterAction() {
        this.filterVisible = false;
      },
      /**
       * 获取生产商列表
       * @param {boolean} init 是否初始化
       */
      getManufacturer(init) {
        axios.get(
          `${config.PHPHOST}api/web/index.php?r=second/search/get-companys&companyName=${this.modelManufacturer}&page=${this.manufacturerPage}&pageSize=10&type=${this.typeIndex == 0 ? 1 : 2}&keyWord=${this.keyword}`
        )
          .then(r => {
            this.isManufacturerLoading = false;
            r = r.data;
            if (r.error_code === 0) {
              this.manufacturerList = [...this.manufacturerList, ...[r.data.model || []]];
              r.data.model && r.data.model.forEach(v => {
                this.manufacturerKeys.push(false);
              });
              this.manufacturerList.forEach((v, k) => {
                this.companyIds.forEach(v1 => {
                  if (v.munufacturer_id == v1) {
                    this.manufacturerKeys[k] = true;
                  }
                });
              });

              if (parseInt(r.data.page) >= r.data.page_count) {
                this.manufacturerLoadOver = true;
              }
            }
          });
      },
      // 生产商列表滚动加载
      manufacturerScrollAction(e) {
        if (this.isManufacturerLoading || this.manufacturerLoadOver) return;
        if (this.manufacturerList.length * 44 - 110 < e.target.scrollTop) {
          this.isManufacturerLoading = true;
          this.manufacturerPage++;
          this.getManufacturer();
        }
      },
      // 搜索生产商列表
      searchManufacturerAction(e) {
        if (e.keyCode === 13) {
          this.manufacturerList = [];
          this.isManufacturerLoading = true;
          this.manufacturerLoadOver = false;
          this.manufacturerPage = 1;
          this.manufacturerKeys = [];
          this.getManufacturer();
        }
      },
      searchManufacturerActionByBtn() {
        this.manufacturerList = [];
        this.isManufacturerLoading = true;
        this.manufacturerLoadOver = false;
        this.manufacturerPage = 1;
        this.manufacturerKeys = [];
        this.getManufacturer();
      },
      /**
       * 选择生产商
       * @param {Object} index 索引
       */
      selectManufacturerItem(index) {
        let temp = [...this.manufacturerKeys];
        temp[index] = !temp[index];
        this.manufacturerKeys = temp;
      },
      // 设置生产商内容可视化
      setManufacturerContentVisible() {
        this.manufacturerContentVisible = !this.manufacturerContentVisible;
      },
      // 获取性能列表
      getPerformance() {
        axios.post(`${config.PHPHOST}api/web/index.php?r=second/search/ajax-physical`, qs.stringify({
          name: this.modelPerformance,
          page: this.performancePage,
          pageSize: 10,
          keyWord: this.keyword
        }))
          .then(r => {
            this.isPerformanceLoading = false;
            r = r.data;
            if (r.error_code === 0) {
              this.performanceList = [...this.performanceList, ...r.data.model];
              r.data.model.forEach(v => {
                this.performanceKeys.push(false);
                this.performanceModels.push({
                  start: '',
                  end: ''
                });
              });
              if (parseInt(r.data.page) >= r.data.page_count) {
                this.performanceLoadOver = true;
              }
            }
          });
      },
      // 性能列表滚动加载
      performanceScrollAction(e) {
        if (this.isPerformanceLoading || this.performanceLoadOver) return;
        if (document.getElementById('performance-container').offsetHeight - 160 < e.target.scrollTop) {
          this.isPerformanceLoading = true;
          this.performancePage++;
          this.getPerformance();
        }
      },
      // 搜索性能列表
      searchPerformanceAction(e) {
        if (e.keyCode === 13) {
          this.performanceKeys = [];
          this.performanceModels = [];
          this.performanceList = [];
          this.isPerformanceLoading = true;
          this.performanceLoadOver = false;
          this.performancePage = 1;
          this.getPerformance();
        }
      },
      searchPerformanceActionByBtn() {
        this.performanceKeys = [];
        this.performanceModels = [];
        this.performanceList = [];
        this.isPerformanceLoading = true;
        this.performanceLoadOver = false;
        this.performancePage = 1;
        this.getPerformance();
      },
      /**
       * 选择性能列表
       * @param {Object} index 性能列表索引
       */
      selectPerformanceItem(index) {
        let temp = [...this.performanceKeys];
        temp[index] = !temp[index];
        this.performanceKeys = temp;
      },
      // 设置性能内容可视化
      setPerformanceContentVisible() {
        this.performanceContentVisible = !this.performanceContentVisible;
      },
      // 获取配方特点列表
      getFormula() {
        axios.post(`${config.PHPHOST}api/web/index.php?r=second/search/formula-label`, qs.stringify({
          labelName: this.modelFormula,
          page: this.formulaPage,
          pageSize: 10
        }))
          .then(r => {
            this.isFormulaLoading = false;
            r = r.data;
            if (r.error_code === 0) {
              this.formulaList = [...this.formulaList, ...r.data.model];
              r.data.model.forEach(v => {
                this.formulaKeys.push(false);
              });
              if (parseInt(r.data.page) >= r.data.page_count) {
                this.formulaLoadOver = true;
              }
            }
          });
      },
      // 配方特点列表滚动加载
      formulaScrollAction(e) {
        if (this.isFormulaLoading || this.formulaLoadOver) return;
        if (Math.ceil(this.formulaList.length / 2) * 45 - 90 < e.target.scrollTop) {
          this.isFormulaLoading = true;
          this.formulaPage++;
          this.getFormula();
        }
      },
      // 搜索配方列表
      searchFormulaAction(e) {
        if (e.keyCode === 13) {
          this.formulaKeys = [];
          this.formulaList = [];
          this.isFormulaLoading = true;
          this.formulaLoadOver = false;
          this.formulaPage = 1;
          this.getFormula();
        }
      },
      searchFormulaActionByBtn() {
        this.formulaKeys = [];
        this.formulaList = [];
        this.isFormulaLoading = true;
        this.formulaLoadOver = false;
        this.formulaPage = 1;
        this.getFormula();
      },
      /**
       * 选择配方特点列表
       * @param {Object} index 配方特点列表索引
       */
      selectFormulaItem(index) {
        let temp = [...this.formulaKeys];
        temp[index] = !temp[index];
        this.formulaKeys = temp;
      },
      // 设置配方特点内容可视化
      setFormulaContentVisible() {
        this.formulaContentVisible = !this.formulaContentVisible;
      },
      // 设置性能内容可视化
      setPerformanceContentVisible() {
        this.performanceContentVisible = !this.performanceContentVisible;
      },
      // 获取配方分类列表
      getFormulaCate() {
        axios.post(`${config.PHPHOST}api/web/index.php?r=second/search/adhibition-type`)
          .then(r => {
            r = r.data;
            if (r.error_code === 0) {
              this.formulaCateList = [...this.formulaCateList, ...r.data];
              r.data.forEach(v => {
                this.formulaCateKeys.push(false);
              });
              r.data.forEach((v, k) => {
                this.adhibitionIds.forEach(v1 => {
                  if (v.id == v1) {
                    this.formulaCateKeys[k] = true;
                  }
                });
              });
            }
          });
      },

      /**
       * 选择配方分类列表
       * @param {Object} index 配方分类列表索引
       */
      selectFormulaCateItem(index) {
        let temp = [...this.formulaCateKeys];
        temp[index] = !temp[index];
        this.formulaCateKeys = temp;
      },

      // 设置配方分类内容可视化
      setFormulaCateContentVisible() {
        this.formulaCateContentVisible = !this.formulaCateContentVisible;
      },

      // 设置产品分类可视化
      setProContentVisible() {
        this.proContentVisible = !this.proContentVisible;
      },

      // 设置应用分类可视化
      setAppContentVisible() {
        this.appContentVisible = !this.appContentVisible;
      },

      // 筛选确定
      filterConfirmAction() {
        let physicalIds = [],
          physicalStar = [],
          physicalEnd = [],
          productIds = [],
          applicationIds = [],
          companyIds = [],
          adhibitionIds = [],
          formulaLabelIds = [];

        this.manufacturerList.forEach((v, k) => {
          if (this.manufacturerKeys[k]) {
            companyIds.push(v.munufacturer_id);
          }
        });
        this.companyIds = companyIds;
        if (this.typeIndex == 0) {
          this.performanceList.forEach((v, k) => {
            if (this.performanceKeys[k]) {
              physicalIds.push(v.pid);
              physicalStar.push(this.performanceModels[k].start);
              physicalEnd.push(this.performanceModels[k].end);
            }
          });

          let proIds = this.loopGetIds(this.proLevel, [], '', 3, 'product_id');
          let appIds = this.loopGetIds(this.appLevel, [], '', 4, 'id');
          this.physicalIds = physicalIds;
          this.physicalStar = physicalStar;
          this.physicalEnd = physicalEnd;
          this.productIds = proIds;
          this.applicationIds = appIds;
        } else {
          this.formulaList.forEach((v, k) => {
            if (this.formulaKeys[k]) {
              formulaLabelIds.push(v.label_id);
            }
          });
          this.formulaLabelIds = formulaLabelIds;
          this.formulaCateList.forEach((v, k) => {
            if (this.formulaCateKeys[k]) {
              adhibitionIds.push(v.id);
            }
          });
          this.adhibitionIds = adhibitionIds;
        }
        this.hideFilterAction();

        this.page = 1;
        this.list = [];
        this.isLoading = true;
        this.loadOver = false;
        this.loaderVisible = true;
        this.getData();

        // 过滤筛选面板
        this.filterFilteData();

      },
      filterFilteData() {
        // 拼接分类过滤参数
        const paramManufacturer = [],
          paramPerformance = [],
          paramStart = [],
          paramEnd = [],
          paramProduct = [],
          paramApp = [];
        this.manufacturerList.forEach((v, k) => {
          if (this.manufacturerKeys[k]) {
            paramManufacturer.push([v.munufacturer_id, v.munufacturer_name]);
          }
        });

        this.performanceList.forEach((v, k) => {
          if (this.performanceKeys[k]) {
            paramPerformance.push([v.pid, v.name]);
            paramStart.push([this.performanceModels[k].start, v.name]);
            paramEnd.push([this.performanceModels[k].end, v.name]);
          }
        });

        this.proLevelBackups = [];
        this.proLevel.forEach(v => {
          if (v.checked) {
            paramProduct.push([`${v.product_id}-0-0`, v.classification_name, v.product_id, 0]);
            this.proLevelBackups.push(v);
          }
          v.children.forEach(v1 => {
            if (v1.checked) {
              paramProduct.push([`${v.product_id}-${v1.product_id}-0`, v1.classification_name, v1.product_id, 1]);
              this.proLevelBackups.push(v1);
            }
            v1.children.forEach(v2 => {
              if (v2.checked) {
                paramProduct.push([`${v.product_id}-${v1.product_id}-${v2.product_id}`, v2.classification_name, v2.product_id, 2]);
                this.proLevelBackups.push(v2);
              }
            });
          });
        });

        this.appLevelBackups = [];
        this.appLevel.forEach(v => {
          if (v.checked) {
            paramApp.push([`${v.id}-0-0-0`, v.classification_name, v.id, 0]);
            this.appLevelBackups.push(v);
          }
          v.children.forEach(v1 => {
            if (v1.checked) {
              paramApp.push([`${v.id}-${v1.id}-0-0`, v1.classification_name, v1.id, 1]);
              this.appLevelBackups.push(v1);
            }
            v1.children.forEach(v2 => {
              if (v2.checked) {
                paramApp.push([`${v.id}-${v1.id}-${v2.id}-0`, v2.classification_name, v2.id, 2]);
                this.appLevelBackups.push(v2);
              }
              v2.children.forEach(v3 => {
                if (v3.checked) {
                  paramApp.push([`${v.id}-${v1.id}-${v2.id}-${v3.id}`, v3.classification_name, v3.id, 3]);
                  this.appLevelBackups.push(v3);
                }
              });
            });
          });
        });

        this.filterParams = {
          companyName: this.modelManufacturer,
          munufacturer: paramManufacturer,
          physicalName: this.modelPerformance,
          physical: paramPerformance,
          start: paramStart,
          end: paramEnd,
          productCate: paramProduct,
          applicationCate: paramApp
        }

        this.getProAndAppCate();
      },
      // 输入框失去焦点
      inputBlurAction() {
        window.scrollTo(0, 0);
      },
      /**
       * 分类选择
       * @param {object} item 对象数据
       */
      proLevelCheck(item) {
        this.$set(item, 'checked', !item.checked);
      },
      /**
       * 分类显示隐藏
       * @param {object} item 对象数据
       */
      toggleLevelVisible(item) {
        this.$set(item, 'open', !item.open);
      },
      /**
       * 获取产品分类、应用分类
       * @param {boolean} init 是否是第一次初始化
       */
      getProAndAppCate(init) {
        axios.post(`${config.PHPHOST}api/web/index.php?r=second/search/ajax-all-cate`, qs.stringify({
          searchName: this.keyword,
          params: JSON.stringify(this.filterParams)
        }))
          .then(r => {
            if (r.data.error_code === 0) {
              this.proLevel = r.data.data.productCate;
              this.appLevel = r.data.data.applicationCate;

              // 勾选已选产品分类内容
              this.proLevelBackups.forEach(v => {
                this.proLevel.forEach(v1 => {
                  if (v.product_id === v1.product_id) {
                    this.$set(v1, 'checked', true);
                    this.$set(v1, 'open', true);
                  }
                  v1.children.forEach(v2 => {
                    if (v.product_id === v2.product_id) {
                      this.$set(v2, 'checked', true);
                      this.$set(v2, 'open', true);
                    }
                    v2.children.forEach(v3 => {
                      if (v.product_id === v3.product_id) {
                        this.$set(v3, 'checked', true);
                        this.$set(v3, 'open', true);
                      }
                    });
                  });
                });
              });

              // 勾选已选应用分类内容
              this.appLevelBackups.forEach(v => {
                this.appLevel.forEach((v1, k1) => {
                  if (v.id === v1.id) {
                    this.$set(v1, 'checked', true);
                    this.$set(v1, 'open', true);
                  }
                  v1.children.forEach((v2, k2) => {
                    if (v.id === v2.id) {
                      this.$set(v2, 'checked', true);
                      this.$set(v2, 'open', true);
                    }
                    v2.children.forEach((v3, k3) => {
                      if (v.id === v3.id) {
                        this.$set(v3, 'checked', true);
                        this.$set(v3, 'open', true);
                      }
                      v3.children.forEach(v4 => {
                        if (v.id === v4.id) {
                          this.$set(v4, 'checked', true);
                          this.$set(v4, 'open', true);
                        }
                      });
                    });
                  });
                });
              });

              // 初始化产品分类默认选择
              if (this.typeIndex == 0 && init) {
                let tempLevel = [...this.proLevel];
                let queryObj = this.$route.query;
                let queryLevel1 = queryObj.level1 ? queryObj.level1.split(',') : [];
                let queryLevel2 = queryObj.level2 ? queryObj.level2.split(',') : [];
                let queryLevel3 = queryObj.level3 ? queryObj.level3.split(',') : [];
                let tempAppLevel = [...this.appLevel];
                let queryAppLevel1 = queryObj.appLevel1 ? queryObj.appLevel1.split(',') : []
                let queryAppLevel2 = queryObj.appLevel2 ? queryObj.appLevel2.split(',') : []
                let queryAppLevel3 = queryObj.appLevel3 ? queryObj.appLevel3.split(',') : []
                tempLevel.forEach((v) => {
                  queryLevel1.forEach(lv1 => {
                    if (v.product_id === lv1) {
                      this.$set(v, "checked", true);
                      this.$set(v, "open", true);
                    }
                  })
                  v.children.forEach((v1) => {
                    queryLevel2.forEach(lv2 => {
                      if (v1.product_id === lv2) {
                        this.$set(v1, "checked", true);
                        this.$set(v1, "open", true);
                      }
                    })

                    v1.children.forEach((v2) => {
                      queryLevel3.forEach(lv3 => {
                        if (v2.product_id === lv3) {
                          this.$set(v2, "checked", true);
                          this.$set(v2, "open", true);
                        }
                      })
                    });
                  });
                });
                this.proLevel = tempLevel;
                tempAppLevel.forEach((v) => {
                  queryAppLevel1.forEach(av1 => {
                    if (v.id === av1) {
                      this.$set(v, "checked", true);
                      this.$set(v, "open", true);
                    }
                  })

                  v.children.forEach((v1) => {
                    queryAppLevel2.forEach(av2 => {
                      if (v1.id === av2) {
                        this.$set(v1, "checked", true);
                        this.$set(v1, "open", true);
                      }
                    })
                    v1.children.forEach((v2) => {
                      queryAppLevel3.forEach(av3 => {
                        if (v2.id === av3) {
                          this.$set(v2, "checked", true);
                          this.$set(v2, "open", true);
                        }
                      })
                    });
                  });
                });
                this.appLevel = tempAppLevel;
              }
            }
          });
      },
      /**
       * 递归获取拼接Id
       * @param {array} arr 数据数组
       * @param {array} result 结果
       * @param {string} parentStr 上一级字符
       * @param {number} deep 递归深度
       * @param {string} keys 数据需要获取的键值
       * @return {array} result 最后结果
       */
      loopGetIds(arr, result, parentStr, deep, keys) {
        deep = deep || 1;
        arr.forEach(v => {
          let tempStr = '';
          tempStr += parentStr + (v.checked ? v[keys] : '0');
          let matchResult = tempStr.match(/_/g);
          let matchLength = matchResult ? matchResult.length : 0;
          if (v.children.length > 0) {
            if (matchLength < deep - 1) {
              tempStr += '_';
            }
            this.loopGetIds(v.children, result, tempStr, deep, keys);
          } else if (matchLength < deep - 1) {
            for (let i = 0; i < (deep - 1 - matchLength); i++) {
              tempStr += '_0';
            }
            if (!/^(0_)*0$/g.test(tempStr)) result.push(tempStr);
          } else {
            if (!/^(0_)*0$/g.test(tempStr)) result.push(tempStr);
          }
        });
        return Array.from(new Set(result));
      },
      /**
       * 跳转到生产商详情
       * @param {number} id 生产商id
       */
      navigateToMunufacturer(id) {
        event.preventDefault();
        this.$router.push(`/companyDetails?companyId=${id}`);
      },
      /**
       * 发起索样
       * @param {object} item 数据源 
       */
      initiateDemo(item) {

        if (!this.userInfo || !this.userInfo.id) {
          return window.location.href = `${config.USERAPI}mobile/uc/build/login?returnUrl=${encodeURIComponent(window.location.href)}`
        }

        if (!this.userInfo.companyId) {
          return window.location.href = `${config.USERAPI}mobile/uc/build/auth/component`
        }
        this.$router.push(`/demo/form?id=${item.sample_id}`)
      }
    }
  }

</script>
<style lang="less" scoped>
  .search-result {
    width: 100%;
    height: 100%;
    background-color: #0b195c;
    display: flex;
    flex-direction: column;

    .sr-content {
      flex: 1;
      margin-top: 3rem;
      background-color: #f8f8f8;
      border-top-left-radius: 3rem;
      border-top-right-radius: 3rem;

      .search-filter {
        display: flex;
        align-items: center;
        padding: 3rem 2rem;

        p {
          flex: 1;
          text-align: center;
          border-left: 1px solid #ddd;
          color: #666;
          font-size: 1.4rem;

          &:first-child {
            border: 0;
          }

          &.active {
            color: #597eff;
          }

          span {
            display: inline-block;
            padding-right: 2.5rem;
          }

          &.sf-news {
            span {
              background: url('../../assets/images/nicon-news.png') no-repeat right;
              background-size: 1.6rem;
            }

            &.active {
              span {
                background: url('../../assets/images/nicon-news-active.png') no-repeat right;
                background-size: 1.6rem;
              }
            }
          }

          &.sf-hot {
            span {
              background: url('../../assets/images/nicon-hot.png') no-repeat right;
              background-size: auto 1.6rem;
            }

            &.active {
              span {
                background: url('../../assets/images/nicon-hot-active.png') no-repeat right;
                background-size: auto 1.6rem;
              }
            }
          }

          &.sf-filter {
            span {
              background: url('../../assets/images/nicon-filter.png') no-repeat right;
              background-size: auto 1.3rem;
            }
          }
        }
      }
    }

    .search-item {
      padding: 0 2rem;

      li {
        background-color: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        border-radius: 1rem;
        margin-bottom: 2rem;
        padding: .8rem;

        a {
          display: flex;
          align-items: flex-start;

          .search-iteml {
            position: relative;
            flex: 1;
            padding: 0 1rem;
            margin-top: .5rem;
            min-width: 1px;

            .search-pname {
              display: flex;
              align-items: center;

              .search-yl {
                flex: 1;
                min-wdith: 1px;

                img {
                  display: block;
                  height: 1.5rem;
                  margin-left: .5rem;
                }
              }

            }

            &:before {
              content: '';
              clear: both;
              width: .3rem;
              height: 3rem;
              background-color: #597eff;
              border-radius: 1rem;
              display: block;
              position: absolute;
              top: 0;
              left: -.8rem;
            }

            strong {
              color: #333;
              font-size: 1.6rem;
              display: block;
              height: 3rem;
              line-height: 3rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              max-width: 80%;
            }

            p {
              font-size: 1.2rem;
              color: #aaa;
              line-height: 2rem;
              margin-top: .3rem;

              span {
                margin-right: 1rem;
                display: inline-block;
              }
            }
          }

          .search-itemr {
            background-color: #f0f2f7;
            color: #a0a7be;
            text-shadow: 1px 1px 0 #fff;
            font-size: 1.4rem;
            padding: 2rem .8rem;
            border-radius: .6rem;
            width: 4rem;
            text-align: center;

            p {
              width: 3.6rem;
              margin: 0 auto;
            }

            img {
              display: block;
              width: 2rem;
              margin: 1rem auto 0 auto;
            }
          }
        }
      }
    }

    .search-formula-item {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      padding: 0 2rem;

      li {
        width: 46.5%;
        margin: 0 7% 2rem 0;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 20%;
          width: 60%;
          height: 3px;
          background-color: #597eff;
          border-radius: 3px;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }

        a {
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: .5rem;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0 0 5px rgba(0, 0, 0, .2);
          border-radius: 1rem;
        }

        strong {
          display: block;
          height: 45px;
          font-size: 18px;
          line-height: 24px;
          color: #333;
          overflow: hidden;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }

        .characteristic {
          color: #999;
          font-size: 0;
          height: 5.5rem;

          span {
            display: inline-block;
            vertical-align: top;
            width: 100%;
            font-size: 1.2rem;
            margin-top: .5rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:before {
              content: '';
              display: inline-block;
              width: .8rem;
              height: .2rem;
              background-color: #ddd;
              vertical-align: middle;
              margin-right: .5rem;
            }
          }
        }

        p {
          color: #999;
          margin-top: .5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 1.4rem;
        }

        .search-formula-btn {
          position: relative;
          background-color: #f0f2f7;
          color: #a0a7be;
          font-size: 1.3rem;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          border-radius: 1rem;
          padding: 1rem;
          margin-top: 1.5rem;

          &.normal {
            justify-content: center;

            img {
              position: static;
              height: .8rem;
              margin-left: .5rem;
            }
          }

          img {
            position: absolute;
            top: .8rem;
            left: .8rem;
            display: block;
            height: 1.6rem;
            margin-left: 0;
          }
        }
      }
    }

    .search-formula-itemt {
      flex: 1;
      padding: 0 .5rem;
    }

    .a {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      height: 100%;
      padding: 0.5rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background-color: #fff;
      -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 1rem;
    }
  }

  .filter-panel {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    overflow: hidden;
    background-color: rgba(0, 0, 0, .6);
    display: flex;

    .filter-mask {
      flex: 1;
    }

    .filter-panel-content {
      position: relative;
      width: 70%;
      height: 100%;
      float: right;
      background-color: #fff;
      transform: translateX(100%);
      animation: filterPanelAnimation 500ms forwards;
    }

    .filter-panel-form {
      padding: 2rem 2rem 6rem 2rem;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      height: 100%;
      box-sizing: border-box;

      dl {
        border-bottom: 1px solid #eee;
        margin-bottom: 1rem;
        padding-bottom: 1rem;

        &:last-child {
          border-bottom: 0;
          margin-bottom: 0;
        }

        &.active {
          dt {
            img {
              transform: rotate(180deg);
            }
          }

          dd {
            display: block;
          }
        }
      }

      dt {
        font-size: 1.4rem;
        font-weight: bold;
        position: relative;

        img {
          display: block;
          position: absolute;
          width: 1.2rem;
          top: .8rem;
          right: 0;
        }
      }

      dd {
        display: none;
      }
    }

    .filter-panel-search {
      border: 1px solid #cbcbcb;
      border-radius: 3rem;
      padding: .5rem 1rem;
      display: flex;
      align-items: center;
      margin-top: 1.5rem;

      input {
        display: block;
        flex: 1;
        outline: none;
        border: none;
      }

      img {
        display: block;
        width: 2rem;
      }
    }

    ul {
      height: 8.5rem;
      overflow: auto;
      margin: 1.5rem 0 0 0;

      &.row1 {
        li {
          width: 100%;
          margin-right: 0;
        }
      }

      -webkit-overflow-scrolling: touch;

      li {
        width: 45%;
        margin: 0 5% 15px 0;
        float: left;
        border-radius: 2rem;
        border: 2px solid #f3f3f3;
        background-color: #f3f3f3;
        color: #333;
        font-size: 1.2rem;
        padding: 5px 0;
        text-align: center;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 15px;

        &.active {
          color: #597eff;
          border-color: #597eff;
          background-color: #fff;
        }
      }
    }
  }

  .filter-panel-t2 {
    height: 16rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    margin-top: 1.5rem;

    .filter-panel-t2-item {
      strong {
        display: block;
        width: 45%;
        margin: 0 5% 1.5rem 0;
        border-radius: 2rem;
        border: 2px solid #f3f3f3;
        background-color: #f3f3f3;
        color: #333;
        font-size: 1.2rem;
        padding: .5rem 0;
        text-align: center;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.active {
          color: #597eff;
          border-color: #597eff;
          background-color: #fff;
        }
      }

      p {
        display: block;
        padding: 0 0 1.5rem 0;
        display: none;

        &.active {
          display: block;
        }

        input {
          border: 1px solid #ddd;
          width: 35%;
          display: inline-block;
          vertical-align: middle;
          padding: .6rem 4%;
          border-radius: 3rem;
          outline: none;
          text-align: center;
        }
      }
    }
  }

  .filter-panel-t3 {
    ul {
      border-bottom: 1px solid #eee;
      padding-bottom: .6rem;

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .filter-panel-confirm {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -3px 5px rgba(0, 0, 0, .1);
    padding: 1.5rem 0;

    button {
      display: block;
      background-color: #597eff;
      color: #fff;
      border: 0;
      border-radius: 2rem;
      width: 70%;
      margin: 0 auto;
      padding: .8rem 0;
      outline: none;
    }
  }

  .tips {
    width: 100%;
    text-align: center;
    color: #999;
    font-size: 1.2rem;
    padding: 1rem 0;
  }

  .level {
    margin-top: 1.5rem;

    &.active {
      .level-dt {
        &>img {
          transform: rotate(180deg);
        }
      }

      .level-dd {
        display: block;
      }
    }

    .level-dt {
      display: flex;
      align-items: center;
      background-color: #eaecf8;
      border-radius: 2rem;
      padding: 1rem 1.5rem;
      font-size: 1.2rem;

      p {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        img {
          width: 1rem;
          height: 1rem;
          margin: -2px .5rem 0 0;
          display: inline-block;
          vertical-align: middle;
        }
      }

      img {
        display: block;
        width: .9rem;
      }
    }

    .level-dd {
      display: none;
      margin-top: 1rem;
    }

    .level-item {
      &.level2 {
        padding: 0 1.5rem;
      }

      &.level3,
      &.level4 {
        padding-left: 2rem;
      }

      &.active {
        &>.level-item-dt {
          img:last-child {
            transform: rotate(180deg);
          }
        }

        &>.level-item-dd {
          display: block;
        }
      }

      .level-item-dt {
        display: flex;
        align-items: center;
        padding: 1rem 0;

        p {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          img {
            width: 1rem;
            height: 1rem;
            margin: -2px .5rem 0 0;
            display: inline-block;
            vertical-align: middle;
          }
        }

        img {
          display: block;
          width: .9rem;
        }
      }

      .level-item-dd {
        display: none;
      }
    }
  }

  .pro-desc {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      display: inline !important;
    }
  }

  .label-join {
    width: 2.4rem;
    height: 2.4rem;
    margin-left: .5rem;
  }

  .label-recom {
    height: 1.8rem;
    margin-left: .5rem;
  }

  @keyframes filterPanelAnimation {
    from {
      transform: translateX(100%);
    }

    to {
      transform: translateX(0);
    }
  }

  .sybtn {
    text-align: right;
    margin: 1rem 0.5rem 0.5rem 0;
  }

  .wygy-btn {
    display: inline-block;
    background: #0c317a;
    color: #fff;
    height: 2.5rem;
    line-height: 2.5rem;
    width: 8rem;
    font-size: 1rem;
    border-radius: 5px;
    cursor: pointer;
    text-align: center;
    font-style: normal;
  }

</style>



// WEBPACK FOOTER //
// src/components/search/result.vue